<div class="banner">
  <a [href]="linkUrl" target="_blank">
    <img class="banner__img" [src]="imgUrl" />
  </a>
</div>
